import api from '@tyrio/api-factory';
import { DBFittingBoxSettingsApi } from '@tyrio/dto';
import { ToastHelper, ToastMessageType, ToastType } from '@tyrio/ui-library';
import { useMutation } from 'react-query';

export const useDeleteFittingBox = (refetchFittingBoxSettings: () => void) => {
  const deleteFittingBox = useMutation(
    (data: DBFittingBoxSettingsApi['delete']['requestBody']) => {
      return api.fetch<DBFittingBoxSettingsApi['delete']>(
        'delete_fitting_box_settings',
        {
          ...data,
        }
      );
    },
    {
      onSuccess: () => {
        refetchFittingBoxSettings();
        ToastHelper.showToast(
          'Fitting box',
          ToastType.SUCCESS,
          ToastMessageType.DELETE
        );
      },
      onError: () => {
        ToastHelper.showToast(
          'Fitting box',
          ToastType.ERROR,
          ToastMessageType.ERROR,
          'An error occurred on delete fitting box!'
        );
      },
    }
  );

  return { deleteFittingBox };
};
